/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Invitation,
  InviteRequest,
  PaginatedInvitationList,
  PatchedTeamMemberRequest,
  TeamInvitationsListParams,
  TeamMember,
  TeamPositions
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type teamInvitationsListResponse200 = {
  data: PaginatedInvitationList
  status: 200
}
    
export type teamInvitationsListResponseSuccess = (teamInvitationsListResponse200) & {
  headers: Headers;
};
;

export type teamInvitationsListResponse = (teamInvitationsListResponseSuccess)

export const getTeamInvitationsListUrl = (params?: TeamInvitationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/team/invitations/?${stringifiedParams}` : `/api/v1/team/invitations/`
}

export const teamInvitationsList = async (params?: TeamInvitationsListParams, options?: RequestInit): Promise<teamInvitationsListResponse> => {
  
  return apiFetch<teamInvitationsListResponse>(getTeamInvitationsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getTeamInvitationsListQueryKey = (params?: TeamInvitationsListParams,) => {
    return [
    `/api/v1/team/invitations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTeamInvitationsListQueryOptions = <TData = Awaited<ReturnType<typeof teamInvitationsList>>, TError = unknown>(params?: TeamInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamInvitationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamInvitationsList>>> = ({ signal }) => teamInvitationsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamInvitationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamInvitationsListQueryResult = NonNullable<Awaited<ReturnType<typeof teamInvitationsList>>>
export type TeamInvitationsListQueryError = unknown


export function useTeamInvitationsList<TData = Awaited<ReturnType<typeof teamInvitationsList>>, TError = unknown>(
 params: undefined |  TeamInvitationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamInvitationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof teamInvitationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamInvitationsList<TData = Awaited<ReturnType<typeof teamInvitationsList>>, TError = unknown>(
 params?: TeamInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamInvitationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof teamInvitationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamInvitationsList<TData = Awaited<ReturnType<typeof teamInvitationsList>>, TError = unknown>(
 params?: TeamInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamInvitationsList<TData = Awaited<ReturnType<typeof teamInvitationsList>>, TError = unknown>(
 params?: TeamInvitationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamInvitationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type teamInvitationsCreateResponse201 = {
  data: Invitation
  status: 201
}
    
export type teamInvitationsCreateResponseSuccess = (teamInvitationsCreateResponse201) & {
  headers: Headers;
};
;

export type teamInvitationsCreateResponse = (teamInvitationsCreateResponseSuccess)

export const getTeamInvitationsCreateUrl = () => {


  

  return `/api/v1/team/invitations/`
}

export const teamInvitationsCreate = async (inviteRequest: InviteRequest, options?: RequestInit): Promise<teamInvitationsCreateResponse> => {
  
  return apiFetch<teamInvitationsCreateResponse>(getTeamInvitationsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      inviteRequest,)
  }
);}




export const getTeamInvitationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsCreate>>, TError,{data: InviteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsCreate>>, TError,{data: InviteRequest}, TContext> => {

const mutationKey = ['teamInvitationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamInvitationsCreate>>, {data: InviteRequest}> = (props) => {
          const {data} = props ?? {};

          return  teamInvitationsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamInvitationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof teamInvitationsCreate>>>
    export type TeamInvitationsCreateMutationBody = InviteRequest
    export type TeamInvitationsCreateMutationError = unknown

    export const useTeamInvitationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsCreate>>, TError,{data: InviteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teamInvitationsCreate>>,
        TError,
        {data: InviteRequest},
        TContext
      > => {

      const mutationOptions = getTeamInvitationsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type teamInvitationsResendCreateResponse201 = {
  data: Invitation
  status: 201
}
    
export type teamInvitationsResendCreateResponseSuccess = (teamInvitationsResendCreateResponse201) & {
  headers: Headers;
};
;

export type teamInvitationsResendCreateResponse = (teamInvitationsResendCreateResponseSuccess)

export const getTeamInvitationsResendCreateUrl = (id: string,) => {


  

  return `/api/v1/team/invitations/${id}/resend/`
}

export const teamInvitationsResendCreate = async (id: string, options?: RequestInit): Promise<teamInvitationsResendCreateResponse> => {
  
  return apiFetch<teamInvitationsResendCreateResponse>(getTeamInvitationsResendCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getTeamInvitationsResendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsResendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsResendCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['teamInvitationsResendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamInvitationsResendCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  teamInvitationsResendCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamInvitationsResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof teamInvitationsResendCreate>>>
    
    export type TeamInvitationsResendCreateMutationError = unknown

    export const useTeamInvitationsResendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsResendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teamInvitationsResendCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTeamInvitationsResendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type teamInvitationsRevokeCreateResponse200 = {
  data: Invitation
  status: 200
}
    
export type teamInvitationsRevokeCreateResponseSuccess = (teamInvitationsRevokeCreateResponse200) & {
  headers: Headers;
};
;

export type teamInvitationsRevokeCreateResponse = (teamInvitationsRevokeCreateResponseSuccess)

export const getTeamInvitationsRevokeCreateUrl = (id: string,) => {


  

  return `/api/v1/team/invitations/${id}/revoke/`
}

export const teamInvitationsRevokeCreate = async (id: string, options?: RequestInit): Promise<teamInvitationsRevokeCreateResponse> => {
  
  return apiFetch<teamInvitationsRevokeCreateResponse>(getTeamInvitationsRevokeCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getTeamInvitationsRevokeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsRevokeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsRevokeCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['teamInvitationsRevokeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamInvitationsRevokeCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  teamInvitationsRevokeCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamInvitationsRevokeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof teamInvitationsRevokeCreate>>>
    
    export type TeamInvitationsRevokeCreateMutationError = unknown

    export const useTeamInvitationsRevokeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamInvitationsRevokeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teamInvitationsRevokeCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTeamInvitationsRevokeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Members of the current agency; the owner and the manager change roles and accesses.
 */
export type teamMembersListResponse200 = {
  data: TeamMember[]
  status: 200
}
    
export type teamMembersListResponseSuccess = (teamMembersListResponse200) & {
  headers: Headers;
};
;

export type teamMembersListResponse = (teamMembersListResponseSuccess)

export const getTeamMembersListUrl = () => {


  

  return `/api/v1/team/members/`
}

export const teamMembersList = async ( options?: RequestInit): Promise<teamMembersListResponse> => {
  
  return apiFetch<teamMembersListResponse>(getTeamMembersListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getTeamMembersListQueryKey = () => {
    return [
    `/api/v1/team/members/`
    ] as const;
    }

    
export const getTeamMembersListQueryOptions = <TData = Awaited<ReturnType<typeof teamMembersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamMembersListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamMembersList>>> = ({ signal }) => teamMembersList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamMembersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof teamMembersList>>>
export type TeamMembersListQueryError = unknown


export function useTeamMembersList<TData = Awaited<ReturnType<typeof teamMembersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamMembersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamMembersList>>,
          TError,
          Awaited<ReturnType<typeof teamMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamMembersList<TData = Awaited<ReturnType<typeof teamMembersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamMembersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamMembersList>>,
          TError,
          Awaited<ReturnType<typeof teamMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamMembersList<TData = Awaited<ReturnType<typeof teamMembersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamMembersList<TData = Awaited<ReturnType<typeof teamMembersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamMembersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Members of the current agency; the owner and the manager change roles and accesses.
 */
export type teamMembersPartialUpdateResponse200 = {
  data: TeamMember
  status: 200
}
    
export type teamMembersPartialUpdateResponseSuccess = (teamMembersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type teamMembersPartialUpdateResponse = (teamMembersPartialUpdateResponseSuccess)

export const getTeamMembersPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/team/members/${id}/`
}

export const teamMembersPartialUpdate = async (id: string,
    patchedTeamMemberRequest: PatchedTeamMemberRequest, options?: RequestInit): Promise<teamMembersPartialUpdateResponse> => {
  
  return apiFetch<teamMembersPartialUpdateResponse>(getTeamMembersPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTeamMemberRequest,)
  }
);}




export const getTeamMembersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamMembersPartialUpdate>>, TError,{id: string;data: PatchedTeamMemberRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof teamMembersPartialUpdate>>, TError,{id: string;data: PatchedTeamMemberRequest}, TContext> => {

const mutationKey = ['teamMembersPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamMembersPartialUpdate>>, {id: string;data: PatchedTeamMemberRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  teamMembersPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamMembersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof teamMembersPartialUpdate>>>
    export type TeamMembersPartialUpdateMutationBody = PatchedTeamMemberRequest
    export type TeamMembersPartialUpdateMutationError = unknown

    export const useTeamMembersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamMembersPartialUpdate>>, TError,{id: string;data: PatchedTeamMemberRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof teamMembersPartialUpdate>>,
        TError,
        {id: string;data: PatchedTeamMemberRequest},
        TContext
      > => {

      const mutationOptions = getTeamMembersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-120: the positions of the team and their rights (readable matrix, versioned data).
 */
export type teamPositionsRetrieveResponse200 = {
  data: TeamPositions
  status: 200
}
    
export type teamPositionsRetrieveResponseSuccess = (teamPositionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type teamPositionsRetrieveResponse = (teamPositionsRetrieveResponseSuccess)

export const getTeamPositionsRetrieveUrl = () => {


  

  return `/api/v1/team/positions/`
}

export const teamPositionsRetrieve = async ( options?: RequestInit): Promise<teamPositionsRetrieveResponse> => {
  
  return apiFetch<teamPositionsRetrieveResponse>(getTeamPositionsRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getTeamPositionsRetrieveQueryKey = () => {
    return [
    `/api/v1/team/positions/`
    ] as const;
    }

    
export const getTeamPositionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamPositionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamPositionsRetrieve>>> = ({ signal }) => teamPositionsRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeamPositionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof teamPositionsRetrieve>>>
export type TeamPositionsRetrieveQueryError = unknown


export function useTeamPositionsRetrieve<TData = Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamPositionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof teamPositionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamPositionsRetrieve<TData = Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamPositionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof teamPositionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeamPositionsRetrieve<TData = Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeamPositionsRetrieve<TData = Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teamPositionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeamPositionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




